import {apiResponseTypeEnum} from './api'

export const forgotPasswordErrorMessagesPerResponseType = {
  [apiResponseTypeEnum.ALREADY_REGISTERED]: 'visitor_forgot_password_error_msisdn_already_registered',
  [apiResponseTypeEnum.BLOCKED_USER]: 'visitor_forgot_password_error_max_attempts',
  [apiResponseTypeEnum.CAMPAIGN_CLOSED]: 'visitor_forgot_password_error_campaign_closed',
  [apiResponseTypeEnum.MSISDN_INVALID]: 'visitor_forgot_password_error_msisdn_invalid',
  [apiResponseTypeEnum.MSISDN_NOT_EXIST]: 'visitor_forgot_password_error_msisdn_not_exist',
  [apiResponseTypeEnum.MSISDN_BLACKLISTED]: 'visitor_forgot_password_error_msisdn_blacklisted',
  [apiResponseTypeEnum.WRONG_PIN]: 'visitor_forgot_password_error_verification_code_invalid',
  [apiResponseTypeEnum.PIN_EXPIRED]: 'visitor_forgot_password_error_pin_expired',
  [apiResponseTypeEnum.THIRD_PARTY_PIN_REQUEST_FAILED]: 'visitor_forgot_password_error_third_party_error',
  [apiResponseTypeEnum.THIRD_PARTY_PIN_VERIFICATION_FAILED]: 'visitor_forgot_password_error_third_party_error',
  [apiResponseTypeEnum.THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED]: 'visitor_forgot_password_error_third_party_error'
}



// WEBPACK FOOTER //
// ./src/constants/forgotPassword.js